document.documentElement.classList.add("unstick-header");
window.addEventListener("octane.quiz.completed", ({
  detail: eventDetail
}) => {
  document.body.classList.add("show-octane-results");
  const {
    quiz_wrapper_element,
    product_blocks
  } = eventDetail;
  const productCards = quiz_wrapper_element.querySelectorAll(".oct-quiz-products__item");
  productCards.forEach((productCard, index) => {
    const originalPrice = productCard.querySelector(".oct-quiz-result-item__pricing");
    const duplicatePrice = originalPrice.cloneNode(true);
    originalPrice.parentNode.insertBefore(duplicatePrice, originalPrice.nextSibling);
    const productBlock = product_blocks[0][index];
    const originalVariantWrapper = productCard.querySelector(".oct-quiz-result-item__variant-wrapper");
    const originalSelect = originalVariantWrapper.querySelector("select");
    const sellingPlans = productCard.querySelector(".oct-quiz-actions-selling-plans-wrapper");
    const duplicateVariantWrapper = originalVariantWrapper.cloneNode(true);
    const duplicateSelect = duplicateVariantWrapper.querySelector("select");
    duplicateSelect.id = `${originalSelect.id}_duplicate`;
    originalVariantWrapper.parentNode.insertBefore(duplicateVariantWrapper, originalVariantWrapper.nextSibling);
    const originalOptions = Array.from(originalSelect.options).map(option => option.cloneNode(true));
    const manageSelectOptions = (showOneTimeOption = false) => {
      duplicateSelect.innerHTML = "";
      originalOptions.forEach(option => {
        if (option.value === "-1") {
          return;
        }
        if (option.value === "0") {
          if (showOneTimeOption) {
            duplicateSelect.appendChild(option.cloneNode(true));
          }
          return;
        }
        if (option !== originalOptions[originalOptions.length - 1]) {
          duplicateSelect.appendChild(option.cloneNode(true));
        }
      });
      duplicateSelect.addEventListener("change", event => {
        originalSelect.value = duplicateSelect.value;
        originalSelect.dispatchEvent(new Event("change", {
          bubbles: true
        }));
        if (duplicateSelect.value !== "0" && sellingPlans) {
          const oneTimeRadio = sellingPlans.querySelector('input[type="radio"][value="false"]');
          oneTimeRadio.click();
          const subscriptionRadio = sellingPlans.querySelector('input[type="radio"][value="true"]');
          subscriptionRadio.click();
          const subscriptionPrice = subscriptionRadio.parentNode.textContent;
          const match = subscriptionPrice.match(/\(([^)]+)\)/);
          duplicatePrice.innerHTML = match ? match[1] : "";
        } else {
          duplicatePrice.innerHTML = productBlock.variants[+duplicateSelect.value].price_formatted;
        }
        if (duplicateSelect.value === "0") ;
      });
    };
    duplicateSelect.addEventListener("change", event => {
      originalSelect.value = duplicateSelect.value;
      originalSelect.dispatchEvent(new Event("change", {
        bubbles: true
      }));
      if (duplicateSelect.value !== "0" && sellingPlans) {
        const oneTimeRadio = sellingPlans.querySelector('input[type="radio"][value="false"]');
        oneTimeRadio.click();
        const subscriptionRadio = sellingPlans.querySelector('input[type="radio"][value="true"]');
        subscriptionRadio.click();
      }
    });
    if (sellingPlans) {
      const duplicateSellingPlans = sellingPlans.cloneNode(true);
      const duplicateRadios = duplicateSellingPlans.querySelectorAll('input[type="radio"]');
      duplicateRadios.forEach(radio => {
        radio.name = `${radio.name}_duplicate`;
        radio.addEventListener("change", e => {
          const originalName = radio.name.replace("_duplicate", "");
          const originalRadio = sellingPlans.querySelector(`input[type="radio"][name="${originalName}"][value="${radio.value}"]`);
          if (radio.value === "false") {
            duplicateSelect.value = 0;
            duplicateVariantWrapper.style.display = "none";
            manageSelectOptions(true);
          } else {
            duplicateSelect.value = 1;
            duplicateVariantWrapper.style.display = "block";
            manageSelectOptions(false);
          }
          duplicateSelect.dispatchEvent(new Event("change", {
            bubbles: true
          }));
          if (originalRadio) {
            originalRadio.checked = true;
            originalRadio.dispatchEvent(new Event("change", {
              bubbles: true
            }));
          } else {
            const updatedSellingPlans = productCard.querySelector(".oct-quiz-actions-selling-plans-wrapper");
            if (updatedSellingPlans) {
              const retryOriginalRadio = updatedSellingPlans.querySelector(`input[type="radio"][name="${originalName}"][value="${radio.value}"]`);
              if (retryOriginalRadio) {
                retryOriginalRadio.checked = true;
                retryOriginalRadio.dispatchEvent(new Event("change", {
                  bubbles: true
                }));
              }
            }
          }
        });
      });
      sellingPlans.parentNode.insertBefore(duplicateSellingPlans, sellingPlans.nextSibling);
      const oneTimeRadio = sellingPlans.querySelector('input[type="radio"][value="false"]');
      if (oneTimeRadio && oneTimeRadio.checked) {
        manageSelectOptions(true);
        duplicateSelect.value = 0;
        duplicateVariantWrapper.style.display = "none";
        duplicateSelect.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      } else {
        manageSelectOptions(false);
        duplicateSelect.value = 1;
        duplicateVariantWrapper.style.display = "block";
        duplicateSelect.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      }
    }
    if (!sellingPlans) {
      manageSelectOptions(true);
      duplicateSelect.value = 0;
      duplicateVariantWrapper.style.display = "none";
      duplicateSelect.dispatchEvent(new Event("change", {
        bubbles: true
      }));
      return;
    }
    const observer = new MutationObserver(mutations => {
      const oneTimeRadio = sellingPlans.querySelector(`input[type="radio"][name="selling_plans_${productBlock.id}_duplicate"][value="false"]`);
      if (!oneTimeRadio) return;
      if (oneTimeRadio.checked) {
        manageSelectOptions(true);
        duplicateSelect.value = 0;
        duplicateVariantWrapper.style.display = "none";
        duplicateSelect.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      } else {
        if (duplicateSelect.value === "-1" || duplicateSelect.value === "0") {
          manageSelectOptions(false);
          duplicateSelect.value = 1;
          duplicateVariantWrapper.style.display = "block";
          duplicateSelect.dispatchEvent(new Event("change", {
            bubbles: true
          }));
        }
      }
    });
    observer.observe(sellingPlans, {
      childList: true,
      subtree: true,
      attributes: true
    });
  });
});
